export default "__VITE_ASSET__5f192c25__"